export default {
  'home.sectionTitle': 'الصفحة الرئيسية',
  'home.menuTitle': 'Overview',
  'revenue.month.current': 'Current month',
  'revenue.month.past': 'Past month',
};
